export default __webpack_public_path__ + "45aba106b72653c264f3ab767a59f69d.png";